<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <CompanyForm />
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import CompanyForm from '@/components/settings/users/company/CompanyForm'

export default {
  name: 'CompanyAdd',
  components: {
    PageTitle,
    PageRowWrapper,
    CompanyForm
  }
}
</script>
